export enum THEME_MODES {
  LIGHT = "light",
  DARK = "dark",
}
